import App from "./App";
import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import "./fonts/SpaceGrotesk-VariableFont_wght.ttf";
import "./fonts/Montserrat-VariableFont_wght.ttf";
import "./fonts/Proxima Nova Font.otf";

const container = document.getElementById("root");
if (!container) throw new Error("Failed to find the root element");
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
